import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import kituLogo from '../assets/kitu-logo.svg';
import { getLogoImg } from '../reducers/customer/actions';

const enableCustomLogo =
  window.env.REACT_APP_ENABLE_CUSTOM_LOGO_UPLOAD === 'true';

const Image = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ display }) => display && `display: ${display}`};
`;

const Logo = ({ height, width, margin, display, getLogoImg, logoImg }) => {
  const [imgSrc, setImgSrc] = useState('');
  useEffect(() => {
    let mounted = true;
    const getAndSetImgSrc = async () => {
      let imgSrc = kituLogo;
      try {
        if (enableCustomLogo) {
          const logo = localStorage.getItem('logo');
          await getLogoImg();
          if (logo) {
            imgSrc = logo;
          }
        }
      } catch (err) {
        if (err) {
          console.error(err);
        }
        imgSrc = kituLogo;
      } finally {
        if (mounted) {
          setImgSrc(imgSrc);
        }
      }
    };
    getAndSetImgSrc();
    return () => (mounted = false);
  }, [logoImg]);

  return (
    <>
      <Image
        width={width}
        height={height}
        margin={margin}
        display={display}
        src={imgSrc}
        alt="Logo Image"
      />
    </>
  );
};

Logo.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  getLogoImg: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    logoImg: state.customer.logoImg
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getLogoImg }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
